export default __webpack_public_path__ + "static/img2-88a219b8a9d57d32cc6541d16573c14d.png";